<template>
  <div class="common-nav">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "tabber",
}
</script>

<style scoped lang="scss">
.common-nav {
  position: fixed;
  right: 0;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 160px;
  box-sizing: border-box;
  border-top:0.5px solid #DFDCDF;;
  text-align: center;
  display: flex;
  justify-content: space-around;
  padding-top: 30px;
  background-color: #FFFFFF;
  z-index: 999;
}
</style>
